/**
 * @generated SignedSource<<0cd0b2a6645b38efbe3b0b17ced1e968>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export enum SpaceSidebarLinkType {
  EXTERNAL_LINK = "EXTERNAL_LINK",
  FORGE = "FORGE",
  PINNED_ATTACHMENT = "PINNED_ATTACHMENT",
  PINNED_BLOG_POST = "PINNED_BLOG_POST",
  PINNED_PAGE = "PINNED_PAGE",
  PINNED_SPACE = "PINNED_SPACE",
  PINNED_USER_INFO = "PINNED_USER_INFO",
  WEB_ITEM = "WEB_ITEM",
}
export type SpaceNavigationQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type SpaceNavigationQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: SpaceNavigationQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_main_SpaceSidebarLink_icon_Icon =
  {
    __typename?: "Icon";
    path: string;
    width: number | null;
    height: number | null;
    isDefault: boolean | null;
  };
export type SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_main_SpaceSidebarLink =
  {
    __typename?: "SpaceSidebarLink";
    id: string;
    webItemKey: string | null;
    webItemCompleteKey: string | null;
    title: string | null;
    url: string | null;
    position: number;
    styleClass: string | null;
    iconClass: string | null;
    hidden: boolean;
    canHide: boolean | null;
    tooltip: string | null;
    linkIdentifier: string | null;
    type: SpaceSidebarLinkType;
    icon: SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_main_SpaceSidebarLink_icon_Icon | null;
  };
export type SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_quick_SpaceSidebarLink =
  {
    __typename?: "SpaceSidebarLink";
    id: string;
    url: string | null;
    position: number;
    title: string | null;
    styleClass: string | null;
  };
export type SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks = {
  __typename?: "SpaceSidebarLinks";
  main: Array<SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_main_SpaceSidebarLink | null> | null;
  quick: Array<SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks_quick_SpaceSidebarLink | null> | null;
};
export type SpaceNavigationQuery_space_Space_icon_Icon = {
  __typename?: "Icon";
  path: string;
};
export type SpaceNavigationQuery_space_Space_homepage_Content = {
  __typename?: "Content";
  id: string | null;
};
export type SpaceNavigationQuery_space_Space_currentUser_SpaceUserMetadata = {
  __typename?: "SpaceUserMetadata";
  isAdmin: boolean;
  isFavourited: boolean;
  isWatched: boolean;
};
export type SpaceNavigationQuery_space_Space_operations_OperationCheckResult = {
  __typename?: "OperationCheckResult";
  operation: string | null;
  targetType: string | null;
};
export type SpaceNavigationQuery_space_Space_history_SpaceHistory = {
  __typename?: "SpaceHistory";
  createdDate: string | null;
};
export type SpaceNavigationQuery_space_Space = {
  __typename?: "Space";
  id: string | null;
  key: string | null;
  name: string | null;
  type: string | null;
  status: string | null;
  containsExternalCollaborators: boolean;
  icon: SpaceNavigationQuery_space_Space_icon_Icon | null;
  homepage: SpaceNavigationQuery_space_Space_homepage_Content | null;
  currentUser?: SpaceNavigationQuery_space_Space_currentUser_SpaceUserMetadata;
  operations: Array<SpaceNavigationQuery_space_Space_operations_OperationCheckResult | null> | null;
  history: SpaceNavigationQuery_space_Space_history_SpaceHistory | null;
};
export type SpaceNavigationQuery_Query = {
  __typename?: "Query";
  user: SpaceNavigationQuery_user_AtlassianUser | null;
  spaceSidebarLinks: SpaceNavigationQuery_spaceSidebarLinks_SpaceSidebarLinks | null;
  space: SpaceNavigationQuery_space_Space | null;
};
export type SpaceNavigationQueryVariables = Exact<{
  spaceKey?: InputMaybe<Scalars["String"]["input"]>;
  isLicensed: Scalars["Boolean"]["input"];
}>;
export type SpaceNavigationQuery = SpaceNavigationQuery_Query;
